import type { FigmaIconProps } from './types';

export const IconFigmaGroup = ({ size = 14, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.80176 0.618083C6.95107 0.564111 7.11714 0.572974 7.2609 0.644857L13.0942 3.56152C13.2919 3.66034 13.4167 3.86238 13.4167 4.08333C13.4167 4.30428 13.2919 4.50633 13.0942 4.60514L7.2609 7.52181C7.09668 7.60392 6.90332 7.60392 6.7391 7.52181L0.905762 4.60514C0.708138 4.50633 0.583333 4.30428 0.583333 4.08333C0.583333 3.86238 0.708138 3.66034 0.905762 3.56152L6.7391 0.644857L6.80176 0.618083ZM2.47119 4.08333L7 6.34774L11.5288 4.08333L7 1.81893L2.47119 4.08333Z"
      fill={color}
    />
    <path
      d="M12.5724 9.39486C12.8606 9.25078 13.2111 9.36761 13.3551 9.65576C13.4992 9.94392 13.3824 10.2944 13.0942 10.4385L7.2609 13.3551C7.09668 13.4373 6.90332 13.4373 6.7391 13.3551L0.905762 10.4385C0.617608 10.2944 0.50078 9.94392 0.644857 9.65576C0.788934 9.36761 1.13942 9.25078 1.42757 9.39486L7 12.1811L12.5724 9.39486Z"
      fill={color}
    />
    <path
      d="M12.5724 6.47819C12.8606 6.33411 13.2111 6.45094 13.3551 6.73909C13.4992 7.02725 13.3824 7.37773 13.0942 7.52181L7.2609 10.4385C7.09668 10.5206 6.90332 10.5206 6.7391 10.4385L0.905762 7.52181C0.617608 7.37773 0.50078 7.02725 0.644857 6.73909C0.788934 6.45094 1.13942 6.33411 1.42757 6.47819L7 9.2644L12.5724 6.47819Z"
      fill={color}
    />
  </svg>
);
